import {EventEmitter, Injectable} from '@angular/core';
import {Media} from "../../models/media";
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  public static IMAGE_TYPE = 'image';
  public static VIDEO_TYPE = 'video';
  public static AUDIO_TYPE = 'audio';

  public mediaImages: Array<Media> = [];
  public mediaVideos: Array<Media> = [];
  public mediaAudios: Array<Media> = [];

  // todo emitter for each type of media
  public onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private http: HttpClient,
  ) {
  }

  private _getAllMedia(media: Array<Media>, type: string) {
    if (type === '' || type === MediaService.IMAGE_TYPE)  this.mediaImages = media.map(m => new Media(m)).filter(m => m.type === 'image');
    if (type === '' || type === MediaService.VIDEO_TYPE)  this.mediaVideos = media.map(m => new Media(m)).filter(m => m.type === 'video');
    if (type === '' || type === MediaService.AUDIO_TYPE)  this.mediaAudios = media.map(m => new Media(m)).filter(m => m.type === 'audio');
  }

  private _postMedia(media: object) {
    if (media['type'] === MediaService.IMAGE_TYPE)  {
      const mediaIndex = this.mediaImages.findIndex(m => m.uri === media['uri'])
      if (mediaIndex >= 0) {
        this.mediaImages[mediaIndex].name = media['name'];
      } else {
        this.mediaImages.push(new Media(media));
      }
    }
    if (media['type'] === MediaService.VIDEO_TYPE)  {
      const mediaIndex = this.mediaVideos.findIndex(m => m.uri === media['uri'])
      if (mediaIndex >= 0) {
        this.mediaVideos[mediaIndex].name = media['name'];
      } else {
        this.mediaVideos.push(new Media(media));
      }
    }
    if (media['type'] === MediaService.AUDIO_TYPE)  {
      const mediaIndex = this.mediaAudios.findIndex(m => m.uri === media['uri'])
      if (mediaIndex >= 0) {
        this.mediaAudios[mediaIndex].name = media['name'];
      } else {
        this.mediaAudios.push(new Media(media));
      }
    }
  }

  private _getOneMedia(media: object) {
    let mediaArrayName = null;

    if (media['type'] === MediaService.IMAGE_TYPE)  mediaArrayName = 'mediaImages';
    if (media['type'] === MediaService.VIDEO_TYPE)  mediaArrayName = 'mediaVideos';
    if (media['type'] === MediaService.AUDIO_TYPE)  mediaArrayName = 'mediaAudios';

    const index = this[mediaArrayName].findIndex(m => m["_id"] === media['_id']);

    if (index > -1) this[mediaArrayName][index] = new Media(media);
    else            this[mediaArrayName].push(new Media(media));
  }

  private _deleteOneMedia(media: object) {
    let mediaArrayName = null;

    if (media['type'] === MediaService.IMAGE_TYPE)  mediaArrayName = 'mediaImages';
    if (media['type'] === MediaService.VIDEO_TYPE)  mediaArrayName = 'mediaVideos';
    if (media['type'] === MediaService.AUDIO_TYPE)  mediaArrayName = 'mediaAudios';

    this[mediaArrayName].splice(this[mediaArrayName].findIndex(m => m["_id"] === media["_id"]), 1);
  }

  getAllMyMedia(projectId: string, language: string = null, type: string = '') {
    return this.http.get('/api/v1/projects/' + projectId + '/media?language=' + language + '&type=' + type).pipe(
      tap(data => this._getAllMedia(data['data']['media'], type))
    )
  }

  postMedia(projectId, media) {
    return this.http.post('/api/v1/projects/' + projectId + '/media', media).pipe(
      tap(
        data => {
          data['data']['media'].map(m => this._postMedia(m));
          this.onChange.emit(true);
        }, err => console.error(err)
      )
    );
  }

  getSingleMedia(projectId: string, mediaId: string) {
    return this.http.get('/api/v1/projects/' + projectId + '/media/' + mediaId).pipe(
      tap(
        data => {
          this._getOneMedia(data['data']['media']);
          this.onChange.emit(true);
        },
        err => console.error(err)
      )
    );
  }

  deleteMedia(projectId: string, mediaId: string, databaseCode: string) {
    return this.http.delete('/api/v1/projects/' + projectId + '/media/' + mediaId + '?code=' + databaseCode).pipe(
      tap(
        data => {
          this._deleteOneMedia(data["data"]["media"]);
          this.onChange.emit(true);
        },
        err => console.error(err)
      )
    );
  }
}
